import { Dispatcher } from '@npm-registry/helpers/dispatcher';
import { ProductId } from '../../store/types';

type ProductDispatcherData = [data: ProductId[]];

// Успешная отчистка корзины
export const OnAfterCartDelete =
  new Dispatcher<ProductDispatcherData>();
